export function instrumentAsyncIterable(instrumentation, name, factory, options) {
    return {
        async *[Symbol.asyncIterator]() {
            const span = instrumentation.startSpan(name, options);
            try {
                for await (const item of factory(span)) {
                    yield item;
                }
                span.end();
            }
            catch (error) {
                span.end(error);
                throw error;
            }
        },
    };
}
//# sourceMappingURL=utils.js.map